import { jsx as _jsx } from "react/jsx-runtime";
import * as Ariakit from '@ariakit/react';
import { forwardRef, useMemo, useState, } from 'react';
import * as Styles from './styles';
export const HeartButtonContent = ({ filled, width = '100%', }) => {
    return _jsx(Styles.Icon, { width: width, renderFillPath: _jsx(Styles.IconFill, { "$filled": filled }) });
};
export const HeartButton = forwardRef(function HeartButton({ disabled, 'aria-disabled': ariaDisabled, filled, as, onClick, children, ...rest }, ref) {
    const [animationEnabled, setAnimationEnabled] = useState(false);
    const handleClick = e => {
        setAnimationEnabled(false);
        requestAnimationFrame(() => {
            setTimeout(() => {
                setAnimationEnabled(true);
                onClick?.(e);
            }, 0);
        });
    };
    const style = useMemo(() => {
        if (animationEnabled) {
            return {
                animationPlayState: 'running',
            };
        }
        else {
            return {
                animationPlayState: 'paused',
                animationName: 'none',
            };
        }
    }, [animationEnabled]);
    return (_jsx(Ariakit.Focusable, { accessibleWhenDisabled: true, disabled: ariaDisabled ?? disabled, style: style, render: _jsx(Styles.Button, { ref: ref, as: as ?? 'button', type: 'button', onClick: handleClick, ...rest }), children: children ?? _jsx(HeartButtonContent, { filled: filled ?? false, width: '100%' }) }));
});
//# sourceMappingURL=index.js.map